const wowApp = require('angular').module('wowApp.shop');

wowApp.directive('wowRescheduleConfirmation', ['$rootScope', '$window','$stateParams','RescheduleDeliveryService', require('./rescheduleconfirmation-directives')]);



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/rescheduleconfirmation/index.js
 **/